import Breadcrumb from '../components/sections/Breadcrumb';

const IntellectualProperty = () => {
  const ipSections = [
    {
      number: 1,
      title: 'Ownership of Content',
      content: 'All content on the Tanzania Digital Awards website, including but not limited to text, graphics, logos, images, audio clips, digital downloads, data compilations, and software, is the property of Tanzania Digital Awards, its affiliates, or content suppliers and is protected by international copyright laws.'
    },
    {
      number: 2,
      title: 'Trademarks',
      content: 'The following are trademarks and service marks of Tanzania Digital Awards:',
      list: [
        '"Tanzania Digital Awards"',
        '"TDA"',
        'The Tanzania Digital Awards logo and design marks',
        'Award category names and descriptions'
      ],
      postContent: 'These marks may not be used without prior written permission from Tanzania Digital Awards.'
    },
    {
      number: 3,
      title: 'License to Use Website',
      content: 'You are granted a limited, non-exclusive, non-transferable license to access and use the Tanzania Digital Awards website for personal, non-commercial purposes only. This license does not include:',
      list: [
        'Any commercial use of the website or its content',
        'Modification, copying, or distribution of content',
        'Use of data mining, robots, or similar data gathering tools',
        'Any use that infringes upon intellectual property rights'
      ]
    },
    {
      number: 4,
      title: 'User-Generated Content',
      content: 'By submitting content to Tanzania Digital Awards (including nominations, testimonials, comments, or other materials), you represent and warrant that:',
      list: [
        'You own or have the necessary rights to the content',
        'The content does not infringe upon any third-party rights',
        'You grant us a perpetual, irrevocable, worldwide, non-exclusive, royalty-free license to use, reproduce, modify, and display the content'
      ]
    },
    {
      number: 5,
      title: 'Copyright Complaints',
      content: 'Tanzania Digital Awards respects the intellectual property rights of others. If you believe that your work has been copied in a way that constitutes copyright infringement, please provide our Copyright Agent with the following information:',
      list: [
        'An electronic or physical signature of the person authorized to act on behalf of the copyright owner',
        'A description of the copyrighted work that you claim has been infringed',
        'A description of where the material is located on the website',
        'Your contact information',
        'A statement that you have a good faith belief that the disputed use is not authorized',
        'A statement that the information in your notice is accurate'
      ]
    },
    {
      number: 6,
      title: 'Third-Party Links',
      content: 'Our website may contain links to third-party websites. We do not claim ownership of any intellectual property on those sites and are not responsible for their content or practices.'
    },
    {
      number: 7,
      title: 'Winner Recognition Rights',
      content: 'Winners of Tanzania Digital Awards grant us the right to use their names, likenesses, and submitted materials for promotional purposes, including but not limited to website display, press releases, and marketing materials.'
    },
    {
      number: 8,
      title: 'Protection of Rights',
      content: 'Tanzania Digital Awards will take appropriate action against any unauthorized use of its intellectual property, including legal action to protect its rights.'
    },
    {
      number: 9,
      title: 'Modifications',
      content: 'Tanzania Digital Awards reserves the right to modify this Intellectual Property Rights policy at any time. Changes will be posted on this page with an updated revision date.'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Breadcrumb title="Intellectual Property Rights" subtitle="IP RIGHTS" />

      <section 
        className="py-16 md:py-20 bg-white"
        style={{
          padding: '4rem 0',
          backgroundColor: '#ffffff'
        }}
      >
        <div 
          className="container mx-auto px-6 md:px-8 lg:px-12" 
          style={{ 
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 1.5rem'
          }}
        >
          <div 
            className="max-w-4xl mx-auto"
            style={{
              maxWidth: '56rem',
              margin: '0 auto'
            }}
          >
            {/* Header Section */}
            <div 
              className="mb-12 text-center"
              style={{
                marginBottom: '3rem',
                textAlign: 'center'
              }}
            >
              <div 
                className="inline-flex items-center px-4 py-2 rounded-full mb-6"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  padding: '0.5rem 1rem',
                  borderRadius: '9999px',
                  backgroundColor: '#FFF7ED',
                  border: '2px solid #ffba17',
                  marginBottom: '1.5rem'
                }}
              >
                <i 
                  className="fa-solid fa-copyright mr-2"
                  style={{
                    color: '#ffba17',
                    marginRight: '0.5rem',
                    fontSize: '1.125rem'
                  }}
                ></i>
                <span 
                  className="text-sm font-semibold uppercase tracking-wider"
                  style={{
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    letterSpacing: '0.05em',
                    textTransform: 'uppercase',
                    color: '#ffba17'
                  }}
                >
                  Intellectual Property Rights
                </span>
              </div>
              <p 
                className="text-gray-500 text-sm"
                style={{
                  color: '#6B7280',
                  fontSize: '0.875rem',
                  marginTop: '1rem'
                }}
              >
                Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>
            </div>

            {/* Content Sections */}
            <div className="space-y-10">
              {ipSections.map((section, idx) => (
                <div 
                  key={section.number}
                  className={idx % 2 === 0 ? "bg-white border-l-4 pl-6 py-4" : "bg-gray-50 rounded-xl p-6 md:p-8"}
                  style={idx % 2 === 0 ? {
                    backgroundColor: 'white',
                    borderLeft: '4px solid #ffba17',
                    paddingLeft: '1.5rem',
                    paddingTop: '1rem',
                    paddingBottom: '1rem'
                  } : {
                    backgroundColor: '#F9FAFB',
                    borderRadius: '0.75rem',
                    padding: '2rem'
                  }}
                >
                  <h2 
                    className="text-2xl md:text-3xl font-bold mb-4"
                    style={{
                      fontSize: 'clamp(1.5rem, 3vw, 1.875rem)',
                      fontWeight: '700',
                      color: '#0f1b3c',
                      marginBottom: '1rem'
                    }}
                  >
                    <span className="mr-3" style={{ color: '#ffba17', marginRight: '0.75rem' }}>{section.number}.</span>
                    {section.title}
                  </h2>
                  <p 
                    className="text-gray-600 leading-relaxed"
                    style={{
                      color: '#4B5563',
                      lineHeight: '1.8',
                      fontSize: '1.0625rem',
                      marginBottom: section.list ? '1rem' : '0'
                    }}
                  >
                    {section.content}
                  </p>
                  {section.list && (
                    <ul className="space-y-3" style={{ marginTop: '1rem' }}>
                      {section.list.map((item, index) => (
                        <li 
                          key={index} 
                          className="flex items-start"
                          style={{
                            display: 'flex',
                            alignItems: 'flex-start'
                          }}
                        >
                          <i 
                            className="fa-solid fa-check-circle mt-1 mr-3"
                            style={{
                              color: '#ffba17',
                              marginTop: '0.25rem',
                              marginRight: '0.75rem',
                              flexShrink: '0'
                            }}
                          ></i>
                          <span 
                            className="text-gray-600 leading-relaxed"
                            style={{
                              color: '#4B5563',
                              lineHeight: '1.75',
                              fontSize: '1rem'
                            }}
                          >
                            {item}
                          </span>
                        </li>
                      ))}
                    </ul>
                  )}
                  {section.postContent && (
                    <p 
                      className="text-gray-600 leading-relaxed mt-4"
                      style={{
                        color: '#4B5563',
                        lineHeight: '1.8',
                        fontSize: '1.0625rem',
                        marginTop: '1rem'
                      }}
                    >
                      {section.postContent}
                    </p>
                  )}
                </div>
              ))}

              {/* Licensing Inquiries Section */}
              <div 
                className="rounded-xl p-8 md:p-10"
                style={{
                  background: 'linear-gradient(135deg, #0f1b3c 0%, #1a2d5c 100%)',
                  borderRadius: '0.75rem',
                  padding: '2.5rem'
                }}
              >
                <h2 
                  className="text-2xl md:text-3xl font-bold mb-4 text-white"
                  style={{
                    fontSize: 'clamp(1.5rem, 3vw, 1.875rem)',
                    fontWeight: '700',
                    color: 'white',
                    marginBottom: '1rem'
                  }}
                >
                  <i 
                    className="fa-solid fa-handshake mr-3"
                    style={{
                      color: '#ffba17',
                      marginRight: '0.75rem'
                    }}
                  ></i>
                  Licensing Inquiries
                </h2>
                <p 
                  className="text-gray-300 mb-6 leading-relaxed"
                  style={{
                    color: '#D1D5DB',
                    marginBottom: '1.5rem',
                    lineHeight: '1.8',
                    fontSize: '1.0625rem'
                  }}
                >
                  For information about licensing our trademarks, content, or other intellectual property, please contact:
                </p>
                <div className="space-y-4">
                  <div 
                    className="flex items-start"
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start'
                    }}
                  >
                    <i 
                      className="fa-solid fa-envelope mt-1 mr-4"
                      style={{
                        color: '#ffba17',
                        marginTop: '0.25rem',
                        marginRight: '1rem',
                        flexShrink: '0'
                      }}
                    ></i>
                    <div>
                      <p 
                        className="text-sm text-gray-400 mb-1"
                        style={{
                          fontSize: '0.875rem',
                          color: '#9CA3AF',
                          marginBottom: '0.25rem'
                        }}
                      >
                        Email
                      </p>
                      <a 
                        href="mailto:info@digitalawards.co.tz"
                        className="text-white hover:text-gold transition-colors"
                        style={{
                          color: 'white',
                          textDecoration: 'none',
                          fontSize: '1.0625rem',
                          cursor: 'pointer'
                        }}
                      >
                        info@digitalawards.co.tz
                      </a>
                    </div>
                  </div>
                  <div 
                    className="flex items-start"
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start'
                    }}
                  >
                    <i 
                      className="fa-solid fa-phone mt-1 mr-4"
                      style={{
                        color: '#ffba17',
                        marginTop: '0.25rem',
                        marginRight: '1rem',
                        flexShrink: '0'
                      }}
                    ></i>
                    <div>
                      <p 
                        className="text-sm text-gray-400 mb-1"
                        style={{
                          fontSize: '0.875rem',
                          color: '#9CA3AF',
                          marginBottom: '0.25rem'
                        }}
                      >
                        Phone
                      </p>
                      <p 
                        className="text-white"
                        style={{
                          color: 'white',
                          fontSize: '1.0625rem'
                        }}
                      >
                        +255 737 957082 / +255 719 579733
                      </p>
                    </div>
                  </div>
                  <div 
                    className="flex items-start"
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start'
                    }}
                  >
                    <i 
                      className="fa-solid fa-map-marker-alt mt-1 mr-4"
                      style={{
                        color: '#ffba17',
                        marginTop: '0.25rem',
                        marginRight: '1rem',
                        flexShrink: '0'
                      }}
                    ></i>
                    <div>
                      <p 
                        className="text-sm text-gray-400 mb-1"
                        style={{
                          fontSize: '0.875rem',
                          color: '#9CA3AF',
                          marginBottom: '0.25rem'
                        }}
                      >
                        Address
                      </p>
                      <p 
                        className="text-white"
                        style={{
                          color: 'white',
                          fontSize: '1.0625rem',
                          lineHeight: '1.75'
                        }}
                      >
                        8th Floor, Victoria House, Mikocheni,<br />Dar es Salaam, Tanzania
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default IntellectualProperty;
